


















import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";

@Component({
  components: {
    Header,
  },
})
export default class Calls extends Vue {
  token = sessionStorage.getItem("token");
  bridge: HTMLIFrameElement | null = null;
  setBridge() {
    this.bridge = document.getElementById("bridge") as HTMLIFrameElement;
    this.bridge.src = this.getBridgeUrl();
    this.setBridgeHeight();
    window.addEventListener("resize", this.setBridgeHeight);
  }
  setBridgeHeight() {
    if (this.bridge) {
      this.bridge.style.height = `${window.innerHeight - 53}px`;
    }
  }
  getBridgeUrl() {
    const { token } = this;
    const { hostname } = window.location;
    let url = "";
    if (hostname.startsWith("localhost")) {
      url = "http://localhost:3000";
    } else if (hostname.includes(".dev.")) {
      url = "https://callr.dev.waitingmed.com";
    } else if (hostname.includes(".stg.")) {
      url = "https://callr.stg.waitingmed.com";
    } else if (hostname.includes(".qa.")) {
      url = "https://callr.qa.waitingmed.com";
    } else if (hostname.includes(".uat.")) {
      url = "https://callr.uat.waitingmed.com";
    } else {
      url = "https://callr.waitingmed.com";
    }
    url += `/wmed_bridge?t=${token}`;
    return url;
  }
  mounted() {
    this.setBridge();
  }
  beforeDestroy() {
    window.removeEventListener("resize", this.setBridgeHeight);
  }
}
